
export const nav = {
  home: 'Home',
  about: 'About',
  courses: 'Courses',
  wallOfFame: 'Wall of Fame',
  workWithUs: 'Work With Us',
  contact: 'Contact'
};

export const cta = {
  bookClass: 'Book Your Class Now',
  startLearning: 'Start Learning Today',
  learnMore: 'Learn More',
  enroll: 'Enroll Now',
  apply: 'Apply Now',
  contact: 'Contact Us',
  readyToStart: 'Ready to Start Learning?',
  joinThousands: 'Join thousands of students who have already achieved success with MathLish'
};

export const hero = {
  title: 'Learn Mathematics and English Online with Expert Teachers',
  subtitle: 'Join thousands of students who have achieved success with MathLish. Personalized learning with experienced teachers.',
  experience: 'Over 20 years of teaching experience',
  qualifiedTeachers: 'Qualified Teachers',
  onlineLearning: 'Online Learning',
  provenResults: 'Proven Results'
};

export const about = {
  title: 'About MathLish',
  subtitle: 'Your path to success in Mathematics and English',
  description: 'MathLish is a leading online platform for learning Mathematics and English, founded by Teacher Iryna, a qualified math teacher with over 20 years of teaching experience.',
  mission: 'Our mission is to make quality education accessible to every student through personalized approach and innovative teaching methods.',
  whyChoose: 'Why Choose MathLish',
  meetTeacher: 'Meet Teacher Iryna',
  ourValues: 'Our Values',
  valuesSubtitle: 'Principles that guide our work',
  ctaSubtitle: 'Join our community and reach new heights in learning',
  countries: 'Countries worldwide',
  qualifications: {
    qualified: 'Qualified Mathematics Teacher',
    experience: 'Over 20 years of teaching experience',
    online: 'Expert in online education',
    founder: 'Founder of MathLish platform'
  },
  values: {
    passion: 'Passion for Learning',
    passionDesc: 'We believe learning should be an exciting and inspiring process',
    innovation: 'Innovative Methods',
    innovationDesc: 'We use the latest technologies and teaching methodologies'
  },
  reasons: {
    experience: 'Experienced Teachers',
    experienceDesc: 'Over 20 years of educational experience',
    personalized: 'Personalized Approach',
    personalizedDesc: 'Individual programs for each student',
    flexible: 'Flexible Schedule',
    flexibleDesc: 'Learn at your convenient time',
    results: 'Proven Results',
    resultsDesc: 'Thousands of successful graduates'
  }
};

export const courses = {
  title: 'Our Courses',
  subtitle: 'Choose the perfect course for your needs',
  mathematics: 'Mathematics',
  english: 'English',
  mathDescription: 'Learn Mathematics with Teacher Iryna',
  englishDescription: 'Learn English with experienced teachers',
  pricing: 'Pricing',
  perClass: 'per class',
  perStudent: 'per student',
  oneOnOne: 'One-on-one',
  twoStudents: 'Two students',
  fourStudents: 'Four students',
  sixStudents: 'Six students',
  whatIncludes: 'What Our Courses Include',
  everythingNeeded: 'Everything you need for successful learning',
  readyToStart: 'Ready to Start Learning?',
  chooseAndStart: 'Choose your course and start your path to success today',
  features: {
    interactive: 'Interactive lessons',
    materials: 'Learning materials',
    support: '24/7 support',
    progress: 'Progress tracking',
    onlineLessons: 'Online Lessons',
    onlineLessonsDesc: 'Interactive video lessons in real time',
    materialsDesc: 'Modern textbooks and additional resources',
    expertTeachers: 'Expert Teachers',
    expertTeachersDesc: 'Experienced and qualified educators',
    flexible: 'Flexible Schedule',
    flexibleDesc: 'Choose convenient time for your lessons',
    supportDesc: '24/7 technical and academic support',
    personalApproach: 'Personal approach',
    flexibleSchedule: 'Flexible schedule',
    individualProgram: 'Individual program',
    interactiveLearning: 'Interactive learning',
    peerInteraction: 'Peer interaction',
    costSaving: 'Cost savings',
    groupDynamics: 'Group dynamics',
    bestPrice: 'Best price',
    socialLearning: 'Social learning',
    conversationPractice: 'Conversation practice',
    pairWork: 'Pair work',
    interactiveTasks: 'Interactive tasks',
    groupDiscussions: 'Group discussions',
    rolePlay: 'Role playing',
    teamwork: 'Teamwork',
    largeProjects: 'Large projects',
    presentations: 'Presentations',
    debates: 'Debates'
  }
};

export const stats = {
  title: 'Our Achievements',
  subtitle: 'Numbers that speak for themselves',
  students: 'Students',
  experience: 'Years Experience',
  success: 'Success Rate',
  support: 'Support'
};

export const wallOfFame = {
  title: 'Wall of Fame',
  subtitle: 'Our students\' achievements',
  achievements: 'Achievements', // ✔️ label
  testimonials: 'Testimonials',
  results: 'Results',
  achievementsSubtitle: 'Our students achieve incredible results',
  testimonialsSubtitle: 'What our students and their parents say',
  ctaTitle: 'Become part of our Wall of Fame!',
  ctaSubtitle: 'Join thousands of successful MathLish students',
  students: {
    alexandra: 'Alexandra Petrenko',
    maxim: 'Maxim Kovalenko',
    anna: 'Anna Sydorenko',
    dmytro: 'Dmytro Ivanenko',
    sofia: 'Sofia Melnyk',
    artem: 'Artem Bondarenko'
  },
  achievement1Data: {
    mathOlympiad: 'Mathematics Olympiad Winner',
    ielts: 'IELTS 8.5 Score',
    university: 'Prestigious University Admission',
    cambridge: 'Cambridge Certificate',
    international: 'International Olympiad',
    toefl: 'TOEFL 115 Score'
  },
  testimonial1Data: {
    maria: 'Maria Shevchenko',
    andriy: 'Andriy Kravchenko',
    olena: 'Olena Hrytsenko',
    mariaText: 'Thank you MathLish for excellent results! My daughter significantly improved.',
    andriyText: 'Thanks to English lessons at MathLish, I scored 8 on IELTS! I recommend to others.',
    olenaText: 'Professional approach and individual attention to each student. My son shows great progress.'
  }
};

  
 export const userData = {
  roles: {
    mother: "Student's Mother",
    student: 'Student',
    father: "Student's Father"
  },
  stats: {
    graduates: 'Successful Graduates',
    improvement: 'Grade Improvement',
    university: 'University Admission',
    satisfaction: 'Satisfaction Rating'
  }
};


export const workWithUs = {
  title: 'Work With Us',
  subtitle: 'Join our team of teachers',
  description: 'We are looking for talented Mathematics and English teachers to join our team.',
  requirements: 'Requirements',
  benefits: 'Benefits',
  applicationForm: 'Application Form',
  joinTeam: 'Join Our Teaching Team',
  whyJoin: 'Why Join MathLish?',
  whyJoinDesc: 'MathLish is a place where your talent will flourish to its fullest',
  openPositions: 'Open Positions',
  findPosition: 'Find your perfect position in our team',
  joinProfessionals: 'Join our team of professionals',
  fillForm: 'Fill out the form and we will contact you soon',
  sendResume: 'Send Resume',
  apply: 'Apply Now',
  askQuestion: 'Ask Question',
  readyToJoin: 'Ready to join our team?',
  sendResumeToday: 'Send your resume and become part of MathLish today!',
  applicationProcess: 'Application Process',
  processDesc: 'Simple and transparent selection process',
  employment: {
    fullTime: 'Full-time',
    partTime: 'Part-time'
  },
  location1: {
    online: 'Online',
    remote: 'Remote'
  },
  requirements1: {
    education: 'Higher education in the field',
    experience: 'Minimum 2 years of teaching experience',
    knowledge: 'Excellent subject knowledge',
    online: 'Online teaching experience (preferred)',
    communication: 'Communication skills',
    responsibility: 'Responsibility and punctuality',
    englishLevel: 'English level not lower than C1',
    pedagogical: 'Pedagogical education',
    curriculum: 'Experience in curriculum development',
    technology: 'Knowledge of modern educational technologies',
    analytical: 'Analytical skills'
  },
  benefits1: {
    salary: 'Competitive salary',
    salaryDesc: 'Competitive salary and bonus system',
    schedule: 'Flexible work schedule',
    scheduleDesc: 'Ability to plan your own working hours',
    remote: 'Remote work opportunity',
    development: 'Professional development',
    developmentDesc: 'Free professional development courses',
    team: 'Friendly team',
    teamDesc: 'Colleague support and comfortable work atmosphere',
    technology: 'Modern learning technologies',
    technologyDesc: 'Work with the latest educational platforms',
    package: 'Social Package',
    packageDesc: 'Health insurance and additional benefits'
  },
  positions: {
    mathTeacher: 'Mathematics Teacher',
    mathDescription: 'Teaching mathematics to students of various levels',
    mathReq1: 'Higher mathematical education',
    mathReq2: 'Teaching experience from 2 years',
    englishTeacher: 'English Teacher',
    englishDescription: 'Teaching English to different age groups',
    englishReq1: 'Philological education',
    englishReq2: 'TESOL/TEFL certificate (preferred)',
    methodist: 'Methodologist'
  },
  responsibilities: {
    individual: 'Conduct individual and group lessons',
    materials: 'Prepare learning materials',
    assessment: 'Assess student progress',
    parents: 'Interact with student parents',
    interactive: 'Conduct interactive English lessons',
    exams: 'Prepare for international exams',
    monitoring: 'Monitor student success',
    development: 'Develop learning materials',
    analysis: 'Analyze effectiveness of learning programs',
    support: 'Support teachers',
    quality: 'Control quality of educational process'
  },
  steps: {
    submit: 'Submit Resume',
    submitDesc: 'Send your resume through the contact form',
    interview: 'Interview',
    interviewDesc: 'Online interview with HR manager and methodologist',
    demo: 'Demo Lesson',
    demoDesc: 'Conduct a demonstration lesson',
    contract: 'Contract',
    contractDesc: 'Sign contract and start working'
  },
  form: {
    name: 'Full Name',
    email: 'Email',
    phone: 'Phone',
    subject: 'Teaching Subject',
    experience: 'Teaching Experience (years)',
    message: 'Tell us about yourself and your experience',
    send: 'Submit Application',
    sending: 'Sending...',
    namePlaceholder: 'Enter your full name',
    selectSubject: 'Select subject',
    selectExperience: 'Select experience',
    'exp1-2': '1-2 years',
    'exp3-5': '3-5 years',
    'exp6-10': '6-10 years',
    'exp10+': 'More than 10 years',
    messagePlaceholder: 'Tell us about your education, teaching experience, methods you use...',
    maxChars: 'Maximum 500 characters',
    successMessage: 'Thank you for your application! We will contact you soon.',
    errorMessage: 'An error occurred while submitting the form. Please try again.'
  }
};

export const contact = {
  title: 'Contact Us',
  subtitle: 'Ready to start learning? Contact us today!',
  getInTouch: 'Get in Touch',
  contactInfo: 'Contact Information',
  sendMessage: 'Send Us a Message',
  chooseMethod: 'Choose a convenient way to contact us',
  workingHours: 'Working Hours',
  schedule: 'Mon-Fri: 9:00-18:00',
  form: {
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    subject: 'Subject',
    message: 'Message',
    send: 'Send Message',
    sending: 'Sending...',
    namePlaceholder: 'Your name',
    messagePlaceholder: 'Tell us more about your question or request...',
    selectSubject: 'Select a topic',
    maxChars: 'Maximum 500 characters',
    successMessage: 'Thank you for your message! We will contact you soon.',
    errorMessage: 'An error occurred while sending the message. Please try again.'
  },
  subjects: {
    enrollment: 'Course enrollment',
    pricing: 'Pricing questions',
    schedule: 'Class schedule',
    technical: 'Technical support',
    other: 'Other'
  },
  faq: {
    title: 'Frequently Asked Questions',
    booking: {
      question: 'How do I book a lesson?',
      answer: 'You can book through the form on our website, call us, or send an email. We will contact you to arrange the details.'
    },
    schedule: {
      question: 'Can I change the lesson time?',
      answer: 'Yes, we offer flexible scheduling. Let us know in advance, and we will find a convenient time to reschedule your lesson.'
    },
    technical: {
      question: 'What are the technical requirements for online lessons?',
      answer: 'You need a computer or tablet with a camera, microphone, and stable internet connection. We use convenient platforms for learning.'
    },
    materials: {
      question: 'Do you provide learning materials?',
      answer: 'Yes, all necessary learning materials are provided free of charge. This includes textbooks, assignments, and additional resources.'
    }
  }
};

export const footer = {
  description: 'Leading online platform for learning Mathematics and English with experienced teachers.',
  quickLinks: 'Quick Links',
  contact: 'Contact',
  location: 'Ukraine',
  rights: 'All rights reserved.'
};

export default {
  nav,
  cta,
  hero,
  about,
  courses,
  stats,
  wallOfFame,
  workWithUs,
  contact,
  footer
};
